import Swiper from "./swiper-bundle.esm.browser.min.js";

if (!customElements.get("secondary-nav")) {
  customElements.define(
    "secondary-nav",
    class SecondaryNav extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.scrollableElement = this.querySelector(
          ".secondary-navigation__ul",
        );
        this.container = this.querySelector(".secondary-navigation");
        this.swiperEl = this.querySelector('.swiper');
        this.dataCenterSlides = this.dataset.centerSlides === '';

       this.initSwiper();
      }

      initSwiper(){
        // functions
        const activeSlideIndex = [...this.swiperEl.querySelectorAll('.swiper-slide')]
          .findIndex((el) => el.classList.contains('secondary-navigation__swiper-slide--active'));

        const centerSlides = (swiperEvent) => {
          const shouldBeCentered = swiperEvent.snapGrid.length === 1 && swiperEvent.snapGrid[0] === -0;
          swiperEvent.wrapperEl.classList.toggle('secondary-navigation__swiper-wrapper--center', shouldBeCentered)
        }

        // swiper initialization
        this.swiper = new Swiper(this.swiperEl, {
          loop: false,
          slidesPerView: 'auto',
          slidesPerGroup: Number(this.dataset.slidesPerGroup) || 1,
          spaceBetween: 0,
          threshold: 10,
          // Start on the active link without animating, matching the position set before the first paint.
          initialSlide: Math.max(activeSlideIndex, 0),
          init: false,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        });

        if (this.dataCenterSlides){
          this.swiper.on('init', centerSlides)
          this.swiper.on('resize', centerSlides)
        }

        // The arrows page by the visible width instead of a fixed slide count, so a step never shrinks to
        // the leftover distance at either end. Next brings the first cut-off link to the left edge;
        // previous brings the link just before the left edge to the right edge.
        const page = (direction) => {
          const swiper = this.swiper;
          const start = -swiper.translate;
          const end = start + swiper.size;
          const grid = swiper.slidesGrid;
          const last = grid.length - 1;
          // Go straight to the end when the step would leave only a sliver of the row to show.
          const sliver = swiper.size / 3;
          let index;
          if (direction > 0) {
            index = grid.findIndex((left, i) => left + swiper.slidesSizesGrid[i] > end + 1);
            if (index < 0 || -swiper.maxTranslate() - grid[index] < sliver) index = last;
            index = Math.max(index, swiper.activeIndex + 1);
          } else {
            index = grid.findIndex((left) => left >= start - swiper.size - 1);
            if (grid[index] < sliver) index = 0;
            index = Math.min(index, swiper.activeIndex - 1);
          }
          swiper.slideTo(Math.max(0, Math.min(index, last)));
        };
        this.swiper.slideNext = () => page(1);
        this.swiper.slidePrev = () => page(-1);

        // init
        this.swiper.init();
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
      }

    },
  );
}
